"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const services_1 = require("../../../../common/services");
const Loader_1 = __importDefault(require("../../../../common/components/Loader/Loader"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const BookingLinkoutIframe = styled_components_1.default.iframe `
  width: 100%;
  min-height: 99%;
  border: 0;
`;
const LinkStayWrapper = styled_components_1.default.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  padding: 24px;
`;
const extractMarkdownUrl = (value) => {
    if (!value) {
        return '';
    }
    const markdownMatch = value.match(/\((https?:\/\/[^)]+)\)/);
    if (markdownMatch === null || markdownMatch === void 0 ? void 0 : markdownMatch[1]) {
        return markdownMatch[1];
    }
    return value;
};
const getLinkoutDetail = (locale, userToken, content) => {
    if (content.type === 'activity') {
        return services_1.apiService.getActivity(locale, userToken, content.contentId);
    }
    return services_1.apiService.getDirectoryNodeDetail(locale, userToken, content.type, content.contentId);
};
const BookingLinkoutView = ({ userData, content, currentLocale }) => {
    var _a;
    const [resolvedContent, setResolvedContent] = (0, react_1.useState)(content);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [hasLinkoutError, setHasLinkoutError] = (0, react_1.useState)(false);
    const loginProvider = (_a = userData === null || userData === void 0 ? void 0 : userData.loginProviders) === null || _a === void 0 ? void 0 : _a[0];
    const isLoginRequired = Boolean(loginProvider && !loginProvider.loggedIn);
    const redirectBackTo = encodeURIComponent(window.location.href);
    const loginUrl = (loginProvider === null || loginProvider === void 0 ? void 0 : loginProvider.loginUrl) ? `${loginProvider.loginUrl}&redirect_back_to=${redirectBackTo}` : '';
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        setIsLoading(true);
        setHasLinkoutError(false);
        const fetchLinkoutDetail = getLinkoutDetail(currentLocale, userData.token, content);
        fetchLinkoutDetail
            .then((detailData) => {
            if (isMounted) {
                setResolvedContent(detailData);
            }
        })
            .catch(() => {
            if (isMounted) {
                setHasLinkoutError(true);
            }
        })
            .finally(() => {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [content, currentLocale, userData.token]);
    const availability = resolvedContent === null || resolvedContent === void 0 ? void 0 : resolvedContent.availability;
    const venueSlug = window.location.pathname.split('/')[1] || '';
    const linkoutUrl = extractMarkdownUrl(availability === null || availability === void 0 ? void 0 : availability.linkoutUrl);
    const hasNoStays = Array.isArray(userData === null || userData === void 0 ? void 0 : userData.stays) && userData.stays.length === 0;
    const getReturnOrigin = () => {
        const deeplink = (resolvedContent === null || resolvedContent === void 0 ? void 0 : resolvedContent.deeplink) || (content === null || content === void 0 ? void 0 : content.deeplink);
        if (typeof deeplink === 'string' && /^https?:\/\//i.test(deeplink)) {
            try {
                return new URL(deeplink).origin;
            }
            catch (_) {
                return window.location.origin;
            }
        }
        return window.location.origin;
    };
    if (isLoginRequired) {
        window.location.href = loginUrl;
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (isLoading) {
        return react_1.default.createElement(Loader_1.default, null);
    }
    if (hasLinkoutError) {
        return (react_1.default.createElement(LinkStayWrapper, null,
            react_1.default.createElement(material_1.Typography, { variant: "body1" }, i18n_js_1.default.t('booking_linkout_error_contact_reception'))));
    }
    if (hasNoStays) {
        return (react_1.default.createElement(LinkStayWrapper, null,
            react_1.default.createElement(material_1.Typography, { variant: "body1" }, i18n_js_1.default.t('booking_linkout_connect_reservation_to_mssngr_account')),
            react_1.default.createElement(material_1.Button, { variant: "contained", color: "primary", size: "large", onClick: () => (window.location.href = loginUrl) }, "Link stay")));
    }
    if (!linkoutUrl) {
        return (react_1.default.createElement(LinkStayWrapper, null,
            react_1.default.createElement(material_1.Typography, { variant: "body1" }, i18n_js_1.default.t('booking_linkout_error_contact_reception'))));
    }
    const sourceReturnUrl = new URL(`${getReturnOrigin()}/${venueSlug}/booking-linkout-success`);
    if (availability === null || availability === void 0 ? void 0 : availability.id) {
        sourceReturnUrl.searchParams.set('availabilityId', String(availability.id));
    }
    const separator = linkoutUrl.includes('?') ? '&' : '?';
    const linkoutSrc = `${linkoutUrl}${separator}sourceReturnUrl=${encodeURIComponent(sourceReturnUrl.toString())}`;
    return react_1.default.createElement(BookingLinkoutIframe, { title: "InnConcepts Booking", src: linkoutSrc });
};
const mapStoreToProps = store => ({
    userData: store.getValue('userData'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(BookingLinkoutView);
